import { render, staticRenderFns } from "./ResetSinglePassword.vue?vue&type=template&id=4e299900"
import script from "./ResetSinglePassword.vue?vue&type=script&lang=ts"
export * from "./ResetSinglePassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports